import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "relative flex-1 flex flex-col w-full bg-white focus:outline-none",
  "data-test-dialog-container-wrapper": ""
}
const _hoisted_2 = { class: "overflow-y-auto" }
const _hoisted_3 = { class: "max-w-4xl text-center mx-auto text-gray-900 py-4 sm:py-14 px-2" }
const _hoisted_4 = { class: "text-xl sm:text-2xl text-gray-900 leading-7 sm:leading-10 mb-4 font-bold" }
const _hoisted_5 = {
  key: 0,
  "data-test-description": ""
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4 sm:my-10" }, null, -1)
const _hoisted_7 = { class: "text-lg sm:text-2xl text-gray-900 font-bold leading-7 sm:leading-10 mb-4" }
const _hoisted_8 = {
  key: 1,
  "data-test-book-description": ""
}
const _hoisted_9 = { class: "relative mt-10 before:bg-white before:w-full before:h-1 before:block before:-mb-1 before:relative before:z-10" }
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogOverlay = _resolveComponent("DialogOverlay")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_HeadlessUiDialog = _resolveComponent("HeadlessUiDialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_TransitionRoot, {
      show: _ctx.isOpen,
      as: "template"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_HeadlessUiDialog, {
          class: _normalizeClass([_ctx.extendedDialogDomClasses, "fixed inset-0 top-14 sm:!top-72 flex z-60 before:h-28 before:w-full sm:before:block before:absolute before:-top-28 before:hidden"]),
          as: "div"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "transition-opacity ease-in-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "transition-opacity ease-in-out duration-300",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DialogOverlay, { class: "fixed inset-0 top-0 opacity-50 h-full bg-gradient-to-b via-black from-transparent to-black pointer-events-none hidden sm:block" })
              ]),
              _: 1
            }),
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "transition ease-in-out duration-300 transform",
              "enter-from": "translate-y-full",
              "enter-to": "translate-y-0",
              leave: "transition ease-in-out duration-300 transform",
              "leave-from": "translate-y-0",
              "leave-to": "translate-y-full"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.titleWithFallback), 1),
                      (_ctx.description)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.description), 1))
                        : _createCommentVNode("", true),
                      _hoisted_6,
                      _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.bookTitleWithFallback), 1),
                      (_ctx.bookDescription)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.bookDescription), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("iframe", {
                          ref: "ycbmIframe",
                          src: _ctx.iframeSource,
                          class: "w-full border-0 h-96 bg-transparent",
                          allowtransparency: "true"
                        }, null, 8, _hoisted_10)
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}